<template>
  <div class="auth-container">
    <div class="overlay-primary">
      <div class="auth-card">
        <h2>Reset your password</h2>
        <p>Please enter your new password below.</p>

        <form @submit.prevent="resetPassword">
          <div class="form-group">
            <label for="email">Email</label>
            <input v-model="localEmail" id="email" type="email" readonly />
          </div>

          <div class="form-group">
            <label for="password">New Password</label>
            <input
              v-model="password"
              id="password"
              type="password"
              required
              minlength="8"
            />
          </div>

          <div class="form-group">
            <label for="confirmPassword">Confirm Password</label>
            <input
              v-model="password_confirmation"
              id="confirmPassword"
              type="password"
              required
            />
          </div>

          <button type="submit" class="btn-primary" :disabled="loading">
            {{ loading ? 'Resetting...' : 'Reset Password' }}
          </button>
        </form>

        <p class="back-link">
          <router-link to="/login">← Back to Login</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/api'

export default {
  name: "ResetPassword",
  props: ["token", "email"],
  data() {
    return {
      localEmail: "",
      localToken: "",
      password: "",
      password_confirmation: "",
      loading: false,
    };
  },
  mounted() {
    // Get query params from URL if props are missing
    const query = this.$route.query;

    this.localEmail = this.email || query.email || "";
    this.localToken = this.token || query.token || "";

    console.log("Loaded reset token:", this.localToken);
    console.log("Loaded email:", this.localEmail);
  },
  methods: {
    async resetPassword() {
      this.loading = true;
      try {
        const payload = {
          token: this.localToken,
          email: this.localEmail,
          password: this.password,
          password_confirmation: this.password_confirmation,
        };

        console.log('Submitting form data:', payload);

        // ✅ Pass as third argument
        const response = await ApiService.post('/update/password', {}, payload);

        alert(response.Data?.message || response.data?.message || 'Password has been reset successfully!');
        this.$router.push('/login');
      } catch (error) {
        console.error('Password reset failed:', error);

        const errors =
          error.response?.data?.message ||
          Object.values(error.response?.data?.errors || {}).flat().join('\n') ||
          'An error occurred. Please try again.';

        alert(errors);
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>
.auth-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-image: url('/public/19.jpg');
  background-size: cover;
  background-repeat: no-repeat
}

.overlay-primary {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 55, 61, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.auth-card {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 400px;
  text-align: center;
}

.form-group {
  margin-bottom: 1rem;
  text-align: left;
}

label {
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
}

input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.btn-primary {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.btn-primary:disabled {
  background-color: #b7e2c1;
  cursor: not-allowed;
}

.back-link {
  margin-top: 1rem;
}
</style>
